import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateDepartment, Department, UpdateDepartment } from '../models/department.model';
import { PagedResult } from '../models/external-sync.model';

@Injectable({ providedIn: 'root' })
export class DepartmentService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/departments`;

  getAll() { return this.http.get<Department[]>(this.url); }
  getPaged(page: number, pageSize: number, search?: string) {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) params = params.set('search', search);
    return this.http.get<PagedResult<Department>>(`${this.url}/paged`, { params });
  }
  getById(id: string) { return this.http.get<Department>(`${this.url}/${id}`); }
  create(dto: CreateDepartment) { return this.http.post<Department>(this.url, dto); }
  update(id: string, dto: UpdateDepartment) { return this.http.put<Department>(`${this.url}/${id}`, dto); }
  delete(id: string) { return this.http.delete(`${this.url}/${id}`); }
}
